import h3_40 from './hex_images/hex3_h40.png';
import h3_60 from './hex_images/hex3_h60.png';
import h3_80 from './hex_images/hex3_h80.png';
import h6_40 from './hex_images/hex6_w80.png';
import h6_60 from './hex_images/hex6_w120.png';
import h6_80 from './hex_images/hex6_w160.png';

const hexes = {
  h3_40,
  h3_60,
  h3_80,
  h6_40,
  h6_60,
  h6_80,
};

export default hexes;
